// Visual badge for a student's belt rank — used consistently across all three portals.
// Exported so other surfaces (e.g. belt-colored accents) can reuse the same colors.
export const BELT_MAP = {
  White:                  { bg: '#FFFFFF', border: '#D1D5DB', color: '#374151' },
  'White-Yellow Stripe':  { bg: '#FFFFFF', border: '#FBBF24', color: '#78350F' },
  Yellow:                 { bg: '#FBBF24', border: '#D97706', color: '#78350F' },
  'Yellow-Green Stripe':  { bg: '#FBBF24', border: '#16A34A', color: '#166534' },
  Green:                  { bg: '#22C55E', border: '#16A34A', color: '#FFFFFF' },
  'Green-Blue Stripe':    { bg: '#22C55E', border: '#2563EB', color: '#FFFFFF' },
  Blue:                   { bg: '#3B82F6', border: '#2563EB', color: '#FFFFFF' },
  'Blue-Red Stripe':      { bg: '#3B82F6', border: '#DC2626', color: '#FFFFFF' },
  Red:                    { bg: '#EF4444', border: '#DC2626', color: '#FFFFFF' },
  'Red-Black Stripe':     { bg: '#EF4444', border: '#111827', color: '#FFFFFF' },
  'Black - 1st Dan':      { bg: '#1F2937', border: '#111827', color: '#FCD34D' },
  'Black - 2nd Dan':      { bg: '#1F2937', border: '#111827', color: '#FCD34D' },
  'Black - 3rd Dan':      { bg: '#1F2937', border: '#111827', color: '#FCD34D' },
  // legacy names — kept for backwards compat
  Orange:                 { bg: '#F97316', border: '#EA580C', color: '#7C2D12' },
  Brown:                  { bg: '#92400E', border: '#78350F', color: '#FFFFFF' },
  Black:                  { bg: '#1F2937', border: '#111827', color: '#FCD34D' },
  'Black (1st Dan)':      { bg: '#1F2937', border: '#111827', color: '#FCD34D' },
  'Black (2nd Dan)':      { bg: '#1F2937', border: '#111827', color: '#FCD34D' },
  'Black (3rd Dan)':      { bg: '#1F2937', border: '#111827', color: '#FCD34D' },
  'Black (4th Dan)':      { bg: '#1F2937', border: '#111827', color: '#FCD34D' },
  'Black (5th Dan)':      { bg: '#1F2937', border: '#111827', color: '#FCD34D' },
};

const SIZE = {
  xs:  { fontSize: '0.65rem',  padding: '2px 8px',    dotSize: 6 },
  sm:  { fontSize: '0.75rem',  padding: '3px 10px',   dotSize: 7 },
  md:  { fontSize: '0.875rem', padding: '5px 14px',   dotSize: 8 },
  lg:  { fontSize: '1.125rem', padding: '8px 20px',   dotSize: 11 },
  xl:  { fontSize: '1.5rem',   padding: '12px 28px',  dotSize: 14 },
};

function BeltBadge({ belt = 'White', size = 'md', className = '' }) {
  const style  = BELT_MAP[belt] || BELT_MAP.White;
  const sz     = SIZE[size] || SIZE.md;

  return (
    <span
      className={`belt-badge inline-flex items-center gap-1.5 rounded-full font-semibold border select-none ${className}`}
      style={{
        background:  style.bg,
        borderColor: style.border,
        color:       style.color,
        '--belt-fg': style.color, // mirrors color so the dark-theme override can re-apply it
        fontSize:    sz.fontSize,
        padding:     sz.padding,
        borderWidth: 2,
      }}
    >
      <span
        style={{
          width:       sz.dotSize,
          height:      sz.dotSize,
          borderRadius: '50%',
          background:  style.border,
          flexShrink:  0,
          display:     'inline-block',
        }}
      />
      {belt}
    </span>
  );
}

export default BeltBadge;
